import {Link, useLocation} from "react-router-dom";
import {Fragment, useContext} from "react";
import {ReducerStateInterface} from "../../interfaces/core/ReducerStateInterface";
import {GlobalContext} from "../../GlobalReducer";
import {PersonFill} from "react-bootstrap-icons";

export default function Breadcrumbs()
{
    const [state, dispatch] = useContext<[ReducerStateInterface, Function]>(GlobalContext);
    const location = useLocation();

    // Don't show breadcrumbs on home page
    if (location.pathname === '/') {
        return null;
    }

    const customerBlock = state.customer && (
        <span className="d-flex align-items-center gap-2 small px-2 py-1 rounded" style={{background: 'var(--bs-gray-100)', border: '1px solid var(--bs-gray-300)'}}>
            <PersonFill style={{color: 'var(--bs-gray-600)'}} />
            <span style={{color: 'var(--bs-gray-800)', fontWeight: 500}}>{state.customer.name}</span>
            <span style={{color: 'var(--bs-gray-700)'}}>#{state.customer.id}</span>
        </span>
    );

    return (<div className="crumbs">
        <div className="container">
            {state.customer && (
                <div className="d-flex d-md-none justify-content-center mb-2">
                    {customerBlock}
                </div>
            )}
            <div className="d-flex align-items-center flex-wrap" style={{gap: '4px 8px'}}>
                <Link to={'/'}>Главная</Link>
                {state.breadcrumbs.map((item, index) => <Fragment key={index}><span>/</span>{item.url ? <Link to={item.url}>{item.name}</Link> : item.name}</Fragment>)}
                {state.customer && (
                    <span className="ms-auto d-none d-md-flex align-items-center gap-2 small px-2 py-1 rounded" style={{background: 'var(--bs-gray-100)', border: '1px solid var(--bs-gray-300)'}}>
                        <PersonFill style={{color: 'var(--bs-gray-600)'}} />
                        <span style={{color: 'var(--bs-gray-800)', fontWeight: 500}}>{state.customer.name}</span>
                        <span style={{color: 'var(--bs-gray-700)'}}>#{state.customer.id}</span>
                    </span>
                )}
            </div>
        </div>
    </div>)
}
